const buttonModalEquipService = {
  text: 'add section'
};

export default buttonModalEquipService;
